if (!customElements.get("vp-megamenu-sidebar")) {
  class MegaMenuSidebar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll(".vp-megamenu-sidebar-links__item");
      this.content = this.querySelectorAll(".vp-mega-menu-sidebar--content-inner");
      this.buttons.forEach((button, i) => {
        button.addEventListener("mouseover", (event) => {
          this.onHover(event, button, i);
        });
      });
    //   this.images = this.querySelectorAll("img");

    //   window.addEventListener("load", (event) => {
    //     this.images.forEach(function (image) {
    //       lazySizes.loader.unveil(image);
    //     });
    //   });
    }

    onHover(event, button, i) {
      this.content.forEach((content, index) => {
        content.classList.remove("active");
        if (i == index) {
          content.classList.add("active");
        }
      });
      this.buttons.forEach((this_button, index) => {
        this_button.classList.remove("active");
      });
      button.classList.add("active");
    }
  }
  customElements.define("vp-megamenu-sidebar", MegaMenuSidebar);
}
